import React from 'react';
import PropTypes from 'prop-types';
import { PossibleMilitaryStatuses } from './possible-military-statuses';
import ChipSelection from './chip-selection';

const toChipOptions = options =>
  options.map(option => ({ label: option.name, value: option.key }));

const MilitaryStatus = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <ChipSelection
      header="Military Status"
      name="militaryStatus"
      options={toChipOptions(PossibleMilitaryStatuses)}
      {...props}
      data-cv-test-override={dataCvTest || 'militaryStatus'}
    />
  );
};

MilitaryStatus.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

MilitaryStatus.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': 'militaryStatus'
};

export default MilitaryStatus;
